import React, { useContext } from 'react';

import PackageContext from '@totem/components/software/software_package/packageContext';
import { isNotNull } from '@totem/utilities/common';

const PackageTitle = () => {
  const { data } = useContext(PackageContext);

  return <span>{isNotNull(data) ? data.package.name : ''}</span>;
};

export default PackageTitle;
